import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {UniqueIdService} from "../../services/UniqueIdService";
import {ForceRankSharedQuestion} from "../../sharedQuestions/ForceRankSharedQuestion";

export class ForceRankQuestionComponent {

    protected uniqueIdService:UniqueIdService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;

    sharedQuestion:ForceRankSharedQuestion;

    question:IQuestion;
    nextQuestionCallback;
    value:string[] = [];

    choices:string[] = [];
    rows:string[] = [];
    style = 'buttons';

    ids = {};

    static $inject = ['UniqueIdService', 'SharedQuestionService', 'SessionService'];

    constructor(UniqueIdService:UniqueIdService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.uniqueIdService = UniqueIdService;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.sharedQuestion = new ForceRankSharedQuestion();

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let style = this.question.meta.style;
        if (style) {
            this.style = style;
        }

        this.choices = this.question.meta.choices;
        if (!this.choices) {
            this.choices = ["Most Like Me", "Least Like Me"];
        }
        for (let choice of this.choices) {
            this.value.push("");
        }

        this.rows = this.question.meta.rows;
        if (!this.rows) {
            throw new Error("No rows found!");
        }

        for (let row = 0; row < this.rows.length; row++) {
            for (let choice = 0; choice < this.choices.length; choice++) {
                const id = row + '-' + choice;
                this.ids[id] = this.uniqueIdService.getUniqueId('radio-grid-' + id);
            }
        }

        let defaultValues = this.question.meta.default;
        if (defaultValues && angular.isArray(defaultValues)) {
            for (let defaultValue of defaultValues) {
                if (defaultValue['choice'] && defaultValue['row']) {
                    let choice = defaultValue['choice'];
                    this.value[choice] = defaultValue['row'];
                    this.update(choice);
                }
            }
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (let value of answer.values) {
                let choice = value.choice;
                this.value[choice] = this.rows[value.row];
                this.update(choice);
            }
        }
    }

    public update(choice:number) {
        if (!this.value[choice]) {
            return;
        }

        let newValue:IValue = {
            choice: choice,
            row: this.rows.indexOf(this.value[choice]),
            value: true
        };
        this.sharedQuestion.setValue(newValue);

        // make sure that there are no two answers in the same row
        const row = this.value[choice];
        for (const otherChoice of this.choices) {
            const otherChoiceIndex = this.choices.indexOf(otherChoice);
            if (row === this.value[otherChoiceIndex] && choice !== otherChoiceIndex) {
                this.value[otherChoiceIndex] = '';
                this.value[otherChoiceIndex] = this.chooseFreeRow(otherChoiceIndex);
                this.update(otherChoiceIndex);
                break;
            }
        }
    }

    protected chooseFreeRow(choice:number) {
        let rows = [];
        angular.copy(this.rows, rows);
        for (const row of this.value) {
            if (this.value[choice] !== row) {
                rows.splice(rows.indexOf(row), 1);
            }
        }

        return rows[0];
    }

}

app.component('forceRankQuestion', {
    templateUrl: 'templates/components/questionTypes/forceRankQuestion.html',
    controller: ForceRankQuestionComponent,
    controllerAs: 'forceRankQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});